// extracted by mini-css-extract-plugin
module.exports = {"covidContainer":"GlobalCases_covidContainer__IAzOi","footer":"GlobalCases_footer__2ED__"};